import { contractorDetailsRoutes } from './features/contractor-details/contractor-details.routes';
import { contractorsListingRoutes } from './features/contractors-listing/contractors-listing.routes';

export const contractorsRoutes = [
  {
    path: '/contractors',
    name: 'contractors',
    meta: {
      requiresAuth: true // all app paths requires authentication
    },
    component: () => import(/* webpackChunkName: "contractors" */ './Contractors.vue'),
    children: [...contractorsListingRoutes, ...contractorDetailsRoutes]
  }
];
